import React, {Fragment} from "react";
import {getMarkup} from "../../../utils/Utils";
import crossBtn from "../../../assets/img/utils/cross.svg";
import {toast} from "react-toastify";
import './RadioButton.scss';

const defaulfBorderColor = "#3BA7E2"
const RadioButton = ({
    isFromCC = false,
    isFirstNotAnsweredQuestion = false,
    isFocused,
    label,
    question,
    checkedOption,
    options,
    onChange,
    cssStyle,
    errorMessage,
    error,
    onClickCrossBtn,
    disabled = false
}) => {

    const onChangeRadio = (e, answerId, answerText, index, title, description) => {
        if (disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        e.preventDefault()
        onChange && onChange({
            question: question,
            answerId: answerId,
            answerText: answerText,
            answerIndex: index,
            title: title,
            description: description
        });
    }

    const toggleIsFromCC = () => {
        onClickCrossBtn && onClickCrossBtn();
    }

    const getFocusColor = () => {
        if (isFocused) {

            if (isFromCC && isFirstNotAnsweredQuestion) {
                return {boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: '5px', border: '2px solid var(--mmh-table-solid-button-background-color)'}
            }
            return {border: '2px solid var(--mmh-table-solid-button-background-color)', borderRadius: "8px", marginRight: "8px"}
        }
    }

    const getBgCol = (bgColor, isChecked) => {
        let backgroundCol = 'white';
        if (isChecked && bgColor) {
            backgroundCol = bgColor;
        } else if (isChecked) backgroundCol = "#3BA7E2";

        return backgroundCol;
    }

    const getBtnTextCol = (optionCol, isChecked) => {
        let textCol = ""; //If no option color is given then text color will be determined from parent element's class
        if (optionCol && isChecked) textCol = "#FFFFFF";
        else if (optionCol) textCol = optionCol;

        return textCol;
    }
    return (
        <>
            {cssStyle === 'row' && (
                <div className="radiobutton__group radiobutton__group--row" style={getFocusColor()}>
                    <label id={`cc-question-${question.questionId}`}
                           className="radiobutton__col-form-label radiobutton__label radiobutton__label--horizontal radiobutton__heading-primary">{label}</label>
                    <div className="radiobutton__d-block">
                        <div className={"width"}>
                            {options && options.length > 0 && (
                                options.map((option, index) =>
                                    <button
                                        className={`radiobutton__edit-assessment-button ${option.id === checkedOption ? 'radiobutton__selected-button' : ''} ${disabled && option.id !== checkedOption ? ' radiobutton__pointer-none radiobutton__cursor-not-allowed ' : (disabled ? ' radiobutton__cursor-not-allowed ' : '')}`}
                                        key={index}
                                        style={{ pointerEvents: disabled ? 'none' : 'auto' }}
                                        onClick={(e) => onChangeRadio(e, option.id, option.name, index, option.title, option.description)}
                                        disabled={option.id === checkedOption ? false : disabled}
                                    >
                                        {option.name}
                                    </button>)
                            )}
                        </div>
                        {errorMessage && (
                            <div className="radiobutton__error-message radiobutton__error-message--d-block">* This field is
                                required</div>)}
                        {error && error?.questionId === question?.questionId && (
                            <span className="radiobutton__text-muted radiobutton__font-danger">* {error?.message}</span>)}
                    </div>
                </div>
            )}
            {cssStyle === 'column' && (
                <div
                    className={`radiobutton__group radiobutton__mb-10 radiobutton__pl-2 ${isFirstNotAnsweredQuestion ? " p-4 " : ""}`}
                    style={getFocusColor()}>
                    <div className="radiobutton__d-flex radiobutton__justify-content-between">
                        <label id={`cc-question-${question.questionId}`}
                               className="radiobutton__col-form-label radiobutton__label radiobutton__label--horizontal radiobutton__heading-primary"
                               dangerouslySetInnerHTML={getMarkup(label)}/>
                        {isFirstNotAnsweredQuestion && (
                            <div className="ml-1 mt-3 cursor-pointer" onClick={toggleIsFromCC}>
                                <img className="cross-btn" src={crossBtn} alt="cross"/>
                            </div>
                        )}
                    </div>

                    <div className="radiobutton__d-flex radiobutton__justify-content-between">
                        <div className="radiobutton__radio-inline">
                            {options && options.length > 0 && (
                                options.map((option, index) =>
                                    <Fragment key={index}>
                                        <button id={`btn-${question.questionId}-${option.id}`}
                                                className={`radiobutton__edit-assessment-button ${option.id === checkedOption ? 'radiobutton__selected-button' : ''} ${disabled && option.id !== checkedOption ? ' radiobutton__pointer-none radiobutton__cursor-not-allowed ' : (disabled ? ' radiobutton__cursor-not-allowed ' : '')}`}
                                                // style={{
                                                //     border: `2px solid ${option.color || defaulfBorderColor}`,
                                                //     backgroundColor: getBgCol(option.color, option.id === checkedOption),
                                                //     pointerEvents: disabled ? 'none' : 'auto'
                                                // }}
                                                disabled={option.id === checkedOption ? false : disabled}
                                                onClick={(e) => onChangeRadio(e, option.id, option.name, index, option.title, option.description)}>
                                            <label
                                                className="radio-btn-label"
                                                // style={{color: getBtnTextCol(option?.color, option?.id === checkedOption)}}
                                                title={
                                                    option?.title
                                                        ? `${option.title}${option?.description ? `: ${option.description}` : ''}`
                                                        : ''
                                                }
                                            >
                                                {option?.name}
                                            </label>

                                        </button>
                                    </Fragment>)
                            )}
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="radiobutton__error-message radiobutton__error-message--d-block">This field is
                            required</div>
                    )}
                    {error && error?.questionId === question?.questionId && (
                        <span className="radiobutton__text-muted radiobutton__font-danger">* {error?.message}</span>
                    )}
                </div>
            )}
        </>
    )
}

export default RadioButton;
